import * as React from "react";

import { BrowseResources } from "./BrowseResources";

import { DSModal } from "../global/DSModal";
import { designTokens } from "../../helpers/constants";
import { usePublishModal } from "./usePublishModal";
import { AttestationLanguage } from "./AttestationLanguage";
import { ExtraItem } from "./Resources";

interface PublishModalProps {
  showModal: boolean;
  hideModal: () => void;
  onPublish: () => void;
  subHeaderText: string;
  error?: string;
  extraItems?: Array<ExtraItem>;
}

export const PublishModal: React.FC<PublishModalProps> = ({
  showModal,
  hideModal,
  onPublish,
  subHeaderText,
  error,
  extraItems,
}: PublishModalProps) => {
  const { selectedResource } = usePublishModal();
  return (
    <DSModal
      fullScreen
      header="Select a TpT Listing"
      show={showModal}
      onCancel={hideModal}
      subHeader={subHeaderText}
      backgroundColor={designTokens["ds-color-gray-lightest"]}
      cancelButtonText="Cancel"
      saveButtonText="Publish"
      saveButtonDisabled={selectedResource === null}
      onSave={onPublish}
      footer={<AttestationLanguage />}
      error={error}
    >
      <BrowseResources extraItems={extraItems} />
    </DSModal>
  );
};
